import { api } from '@/services/api/main/axios';

export type IntegrationListItem = {
  id: string;
  name: string;
  type: string;
  status: string;
  statusMessage?: string;
  accessToken?: string;
  clientId?: string;
  meta?: Record<string, unknown>;
};

export type IntegrationPayload = {
  name: string;
  type?: string;
  accessToken?: string;
  clientId?: string;
  id?: string;
  meta?: Record<string, unknown>;
};

export const getIntegrationsApiRequest = async (): Promise<IntegrationListItem[]> => {
  const res = await api.get<{ payload: IntegrationListItem[] }>('user/integrations');
  return res.data.payload;
};

export const postIntegrationApiRequest = async (payload: IntegrationPayload) => {
  const res = await api.post<{ payload: IntegrationListItem }>('user/integrations', payload);
  return res.data.payload;
};

export const putIntegrationApiRequest = async (payload: IntegrationPayload) => {
  const res = await api.put<{ payload: IntegrationListItem }>(
    `user/integrations/${payload.id}`,
    payload,
  );
  return res.data.payload;
};

export const deleteIntegrationApiRequest = async (id: string) => {
  const res = await api.delete<{ payload: unknown }>(`user/integrations/${id}`);
  return res.data.payload;
};

export const getIntegrationCheckStatusApiRequest = async (id: string) => {
  const res = await api.get<{ payload: IntegrationListItem }>(`user/integrations/${id}/check-status`);
  return res.data.payload;
};
